const steps = [
  {
    number: "01",
    title: "Capture the real source",
    description:
      "Start with a meeting, note, PDF, web clip, image, or sketch. In the sample, a prepared 42-minute discovery call is already there.",
  },
  {
    number: "02",
    title: "Clarify what changed",
    description:
      "Keep the context and evidence, then pull out the decision, key insights, open questions, and useful visual extracts.",
  },
  {
    number: "03",
    title: "Decide what happens next",
    description:
      "Confirm action items and follow-up dates, then add a one-sentence takeaway that makes the note understandable later.",
  },
  {
    number: "04",
    title: "Review, archive, recover",
    description:
      "Use the Review queue to close or archive the note, then retrieve it weeks later with its original context intact.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4">
            One source, all the way to follow-through
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            See the full capture, clarify, act, and review loop before the account ask.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="relative">
              <span className="text-5xl font-extrabold text-indigo-100 mb-4 block">
                {step.number}
              </span>
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
